// extracted by mini-css-extract-plugin
module.exports = {"miniHero":"styles_miniHero__S_hYg","noSubheading":"styles_noSubheading__Vbnf7","body":"styles_body__LIFn3","pattern":"styles_pattern__xCus_"};